import { gql, type TypedDocumentNode } from '@apollo/client';
import type {
  CompleteMyCampaignEntryMutation, CompleteMyCampaignEntryMutationVariables,
  MyCampaignEntryQuery, MyCampaignEntryQueryVariables,
  SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables,
  SuperHeroActivePromotionQuery, SuperHeroActivePromotionQueryVariables,
} from '@/generated/campaign-entry';

export type CampaignEntryState = MyCampaignEntryQuery['myCampaignEntry'];
export type SuperHeroPromotionData = SuperHeroPromotionQuery;
export type SuperHeroActivePromotionData = SuperHeroActivePromotionQuery;

export const MY_CAMPAIGN_ENTRY = gql`
  query MyCampaignEntry {
    myCampaignEntry { account_id campaign_id skip_onboarding }
  }
` as TypedDocumentNode<MyCampaignEntryQuery, MyCampaignEntryQueryVariables>;
export const COMPLETE_MY_CAMPAIGN_ENTRY = gql`
  mutation CompleteMyCampaignEntry($campaignId: ID!) {
    completeMyCampaignEntry(campaignId: $campaignId) { account_id campaign_id skip_onboarding }
  }
` as TypedDocumentNode<CompleteMyCampaignEntryMutation, CompleteMyCampaignEntryMutationVariables>;
export const SUPER_HERO_PROMOTION = gql`
  query SuperHeroPromotion($id: ID!) {
    adminCpmCampaign(id: $id) {
      id name status campaign_type end_date ranking_config logo_url banner_url
    }
  }
` as TypedDocumentNode<SuperHeroPromotionQuery, SuperHeroPromotionQueryVariables>;

export const SUPER_HERO_ACTIVE_PROMOTION = gql`
  query SuperHeroActivePromotion($id: ID!) {
    myCpmCampaign(id: $id) {
      id name status campaign_type end_date ranking_config logo_url banner_url
    }
  }
` as TypedDocumentNode<SuperHeroActivePromotionQuery, SuperHeroActivePromotionQueryVariables>;
